<template>
  <div class="schoolLevel">
    <a-form-model layout="inline" style="display: flex; justify-content: space-around">
      <a-form-model-item label="学生一致">
        <a-switch v-model="uniformity.schoolUniformity" :disabled="IsDetails" :loading="switchLoading" @change="switchChange" checked-children="启用" un-checked-children="禁用" />
      </a-form-model-item>
      <a-form-model-item v-if="tableRelevant.tableDataSource.length">
        <a-dropdown :trigger="['click']" v-model="dropdownVisible" :disabled="IsDetails">
          <a-button @click="(e) => e.preventDefault()">快速配置学生</a-button>
          <a-menu slot="overlay">
            <!-- <a-menu-item key="0" @change="change0">
              <a-checkbox value="0" v-model="checkboxs.a">未开始</a-checkbox>
            </a-menu-item> -->
            <a-menu-item key="1" @change="change0">
              <a-checkbox value="1" v-model="checkboxs.b">进行中</a-checkbox>
            </a-menu-item>
            <a-menu-item key="2" @change="change0">
              <a-checkbox value="2" v-model="checkboxs.c">已完成</a-checkbox>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item>
              <a-button style="margin-right: 15px" @click="quickSetClose()">取消</a-button>
              <a-button type="primary" @click="quickSet()" :disabled="quickSetStudent.length < 1">确定</a-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-form-model-item>
      <a-form-model-item v-if="tableRelevant.tableDataSource.length">
        <a-button @click="resetComputed()" :disabled="IsDetails">重新算分</a-button>
      </a-form-model-item>
      <a-form-model-item v-if="!IsDetails">
        <a-button @click="addRound" type="primary">添加测评</a-button>
      </a-form-model-item>
    </a-form-model>
    <div style="margin: 30px auto; width: 95%">
      <a-table :columns="orgcolumns" row-key="organizationId" :pagination="false" :loading="tableRelevant.tableLoading" :dataSource="tableRelevant.tableDataSource">
        <div slot="organizationName" slot-scope="text"><span v-if="text.hasAnonymous">【匿名】</span>{{ text.organizationName }}</div>
        <div slot="userCount" slot-scope="text">{{ text.userCount || 0 }}/{{ text.totalCount }}</div>
        <div slot="action" slot-scope="text">
          <a-switch
            v-if="$store.getters['organization/getReportInfo'].reportType != 1"
            @change="tableSwitchChange(text)"
            v-model="text.hasAnonymous"
            checked-children="匿名"
            :disabled="IsDetails"
            un-checked-children="不匿名"
          />
          <a-button v-if="!IsDetails" type="link" @click="batchConfigStudent(text)">整体配置学生</a-button>
        </div>
        <StepsSecondCourse
          slot-scope="text"
          slot="expandedRowRender"
          @loading="changeLoading"
          @renewData="getGroupReportCourseInfo"
          :uniformity="uniformity"
          :IsDetails="IsDetails"
          :tableDataSource="text.groupCourseInfos"
        />
      </a-table>
    </div>
    <!-- 添加测评 -->
    <a-modal v-model="course.visible" title="添加测评" width="70%" @ok="courseSubmit" :confirm-loading="course.confirmLoading" :destroyOnClose="true">
      <StepsSecondAddCourse single :select-data="selectTableData" ref="addCourse" :organizationId="organizationId" />
    </a-modal>
    <ConfigStudent ref="configStudentRef" />
  </div>
</template>

<script>
import ManySelect from '@/components/select/ManySelect'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import StepsSecondAddCourse from '@/pages/reportCenter/groupReport_new/components/StepsSecondAddCourse'
import StepsSecondCourse from '@/pages/reportCenter/groupReport_new/components/StepsSecondCourse'
import ConfigStudent from './configStudent.vue'

export default {
  name: 'SchoolLevelSet',
  props: {
    IsDetails: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['update'],
  components: { StepsSecondAddCourse, StepsSecondCourse, ConfigStudent, ManySelect },
  data() {
    return {
      organizationId: this.$store.getters['organization/getReportInfo'].organizationId || undefined,
      //   organizationId: 290271483965509,
      organizationList: [],
      uniformity: {
        schoolUniformity: this.$store.getters['organization/getReportInfo'].studentSampleTakingMethod === 2,
        sampleInsideUniformity: undefined,
        sampleOutsideUniformity: undefined,
      },
      orgcolumns: [
        { title: '机构名称', scopedSlots: { customRender: 'organizationName' } },
        { title: '学生数', scopedSlots: { customRender: 'userCount' } },
        { title: '操作', scopedSlots: { customRender: 'action' }, width: '320px' },
      ],
      columns: [
        { title: '测评名称', dataIndex: 'projectCourseConfigName' },
        { title: '资源名称', dataIndex: 'courseName' },
        { title: '课时名称', dataIndex: 'childCourseName' },
        { title: '学生数', scopedSlots: { customRender: 'student' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ],
      tableRelevant: tableRelevant.call(this),
      switchLoading: false,
      selectTableData: [],
      course: {
        key: Date.now(),
        visible: false,
        confirmLoading: false,
      },
      dropdownVisible: false,
      quickSetStudent: [],
      checkboxs: {
        a: false,
        b: false,
        c: false,
      },
    }
  },
  mounted() {
    // this.getOrganizationList()
    this.getGroupReportCourseInfo()
  },
  watch: {
    dropdownVisible(val) {
      if (!val) {
        this.quickSetStudent = []
        this.checkboxs = {
          a: false,
          b: false,
          c: false,
        }
      }
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.course.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.course.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },
  methods: {
    tableSwitchChange(val) {
      const Form = new FormData()
      Form.append('id', val.groupReportSampleId)
      Form.append('sampleName', val.hasAnonymous ? '学校' + (val.index + 1) : val.sampleName)
      Form.append('groupReportId', this.$store.getters['organization/getReportInfo'].id)
      this.tableRelevant.tableLoading = true
      this.$http.GroupReport.editSample(Form).then((res) => {
        const { status, message } = res
          this.$message.success(message)

      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    async batchConfigStudent(record) {
      await this.$refs['configStudentRef'].showModal({ organizationId: record.organizationId, groupReportId: this.$store.getters['organization/getReportInfo'].id })
      this.getGroupReportCourseInfo()
    },
    changeLoading(bool) {
      this.tableRelevant.tableLoading = bool
    },
    change0(e) {
      if (e.target.checked) {
        this.quickSetStudent.push(+e.target._value)
      } else {
        this.quickSetStudent = this.quickSetStudent.filter((f) => f != e.target._value)
      }
    },
    quickSetClose() {
      this.dropdownVisible = false
      this.quickSetStudent = []
      this.checkboxs = {
        a: false,
        b: false,
        c: false,
      }
    },
    // 快速配置学生
    quickSet() {
      let params = {
        groupReportId: this.$store.getters['organization/getReportInfo'].id,
        userCourseSessionStatus: this.quickSetStudent,
        organizationId: this.organizationId,
      }
      this.$http.ReportService.configGroupStudent(params).then((res) => {
        this.$message.destroy()
        const { status, data, message } = res
        this.$message.success(message)
        this.getGroupReportCourseInfo()
        this.dropdownVisible = false
        this.quickSetStudent = []
        this.checkboxs = {
          a: false,
          b: false,
          c: false,
        }
      })
    },
    // 重新算分
    resetComputed() {
      let that = this
      this.$confirm({
        title: '确认重新算分?',
        content: '重新算分后原有分数将被清空，请确认此操作',
        onOk() {
          let formData = new FormData()
          that.tableRelevant.tableDataSource.forEach((v) => {
            ;(v.groupCourseInfos || []).forEach((item) => {
              formData.append('customerChildCourseIds', item.groupReportCourseSessionId)
              formData.append('customerCourseIds', item.organizationCourseId)
            })
          })
          that.$http.GroupReport.GroupReportUpdateCourseContentScore(formData).then((res) => {
            that.$message.destroy()
            const { status, data, message } = res
              that.$message.success(message)

          })
        },
        onCancel() {},
      })
    },
    switchChange(checked) {
      const reportInfo = this.$store.getters['organization/getReportInfo']
      const Params = {
        groupReportId: reportInfo.id,
        studentSampleTakingMethod: checked ? 2 : 0,
      }
      this.switchLoading = true
      this.$http.GroupReport.updateStudentSampleTakingMethod(Params).then((res) => {
        const { status, data, message } = res
          this.$message.success(message)
          this.getGroupReportCourseInfo()
          this.$store.commit('organization/setReportInfo', {
            ...reportInfo,
            studentSampleTakingMethod: Params.studentSampleTakingMethod,
          })

      }).catch(e => {
        this.switchLoading = false
      })
    },
    addRound() {
      this.course.visible = true
      this.course.key = Date.now()
    },
    // 添加测评
    courseSubmit() {
      this.$message.destroy()
      if (!this.$refs.addCourse.selectedRowKeys.length) {
        this.$message.warning('请选择测评')
        return
      }
      const params = {
        groupReportId: this.$store.getters['organization/getReportInfo'].id,
        params: this.$refs.addCourse.selectedRows.map((m) => ({
          //   groupReportSampleId: this.$store.getters['organization/getReportInfo'].id,
          organizationId: m.organizationId,
          organizationCourseId: m.projectCourseConfigId,
          organizationCourseSessionId: m.id,
        })),
      }
      this.course.confirmLoading = true
      this.$http.ReportService.addGroupReportCourse(params)
        .then((res) => {
          const { status, data, message } = res
          this.course.visible = false
          this.$message.success(message)
          this.getGroupReportCourseInfo()
          this.update && this.update()
        })
        .finally(() => {
          this.course.confirmLoading = false
        })
    },

    // 获取团体报告配置课程信息
    getGroupReportCourseInfo() {
      const reportId = this.$store.getters['organization/getReportInfo'].id
      if (!reportId) return
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.groupReportCourse(reportId)
        .then((res) => {
          this.switchLoading = false
          const { status, data, message } = res
          if (data[0]) {
            this.tableRelevant.tableDataSource = data.map((v) => {
              v.sampleName = v.organizationName
              if (v.groupCourseInfos) {
                v.sampleName = v.groupCourseInfos[0]?.sampleName || v.organizationName
              }
              return v
            })
            this.organizationId = data[0].organizationId
            this.selectTableData = data[0].groupCourseInfos
            this.$store.commit('organization/setReportInfo', { ...this.$store.getters['organization/getReportInfo'], organizationName: data[0].organizationName })
          } else {
            this.tableRelevant.tableDataSource = []
            this.selectTableData = []
            this.organizationId = undefined
          }
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    // 获取机构列表
    getOrganizationList() {
      this.$http.loadAllByType({ isOnlySuperior: false,orgType:1 }).then((res) => {
        const { status, data, message } = res.data
          this.organizationList = data

      })
    },
  },
}
</script>

<style scoped></style>
